import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import en from "./locales/en/translation.json";
import ru from "./locales/ru/translation.json";

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    lng: "ru", // Default language
    fallbackLng: "en", // Fallback language if the current one is missing
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;